import { LoaderFunction, redirectDocument } from 'react-router-dom';

export const signOutRedirectClosure: () => LoaderFunction = () => {
  const signOutRedirect: LoaderFunction = async () => {
    return redirectDocument('/api/auth/logout');
  };

  return signOutRedirect;
};
